import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "app/shared/services/api.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-student-pipelines-matching-results",
  templateUrl: "./student-pipelines-matching-results.component.html",
  styleUrls: ["./student-pipelines-matching-results.component.scss"],
})
export class StudentPipelinesMatchingResultsComponent implements OnInit {
  matchResult: any = null;
  isConfirming: Record<string, boolean> = {};

  constructor(
    private router: Router,
    private apiService: ApiService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.loadLatestResult();
  }

  get matchedRows(): any[] {
    return this.matchResult?.matchedResult || [];
  }

  loadLatestResult(): void {
    const raw = localStorage.getItem("studentPipelineMatchResult");
    this.matchResult = raw ? JSON.parse(raw) : null;
  }

  goBackToList(): void {
    this.router.navigate(["/students-pipeline"]);
  }

  clearResults(): void {
    localStorage.removeItem("studentPipelineMatchResult");
    this.matchResult = null;
  }

  confirmMerge(item: any): void {
    const pipelineId = item?.pipelineData?._id;
    const studentId = item?.studentData?._id;

    if (!pipelineId || !studentId) {
      this.toastr.error("Missing pipeline or student reference for merge");
      return;
    }

    if (this.isConfirming[pipelineId]) {
      return;
    }

    this.isConfirming[pipelineId] = true;
    this.spinner.show();

    this.apiService.confirmStudentPipelineMerge(pipelineId, studentId).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.isConfirming[pipelineId] = false;
        if (res?.statusCode === 200 || res?.isSuccess === true) {
          this.toastr.success(
            res?.message || "Student pipeline merged successfully"
          );
          this.removeMatchedRow(pipelineId);
        } else {
          this.toastr.error(res?.error || "Unable to complete merge");
        }
      },
      (error) => {
        this.spinner.hide();
        this.isConfirming[pipelineId] = false;
        this.toastr.error(
          error?.error?.error || "Unable to confirm merge right now"
        );
      }
    );
  }

  private removeMatchedRow(pipelineId: string): void {
    if (!this.matchResult?.matchedResult) {
      return;
    }

    this.matchResult = {
      ...this.matchResult,
      matchedPipeline: Math.max(
        (this.matchResult?.matchedPipeline || 0) - 1,
        0
      ),
      matchedResult: this.matchResult.matchedResult.filter(
        (record: any) => record?.pipelineData?._id !== pipelineId
      ),
    };

    if (!this.matchResult.matchedResult.length) {
      this.matchResult.unmatched = this.matchResult?.unmatched || 0;
    }

    localStorage.setItem(
      "studentPipelineMatchResult",
      JSON.stringify(this.matchResult)
    );
  }
}

